export default __webpack_public_path__ + "static/media/rodrigue-linda.36a60244.png";